import { fetchAPI } from '../utils/api';

export const getUserFavouriteTags = (): Promise<{
  items: UserFavouriteTag[];
}> => {
  return fetchAPI(`/user_favourite_tags`, {
    version: '1.2',
  }).then(r => r.json());
};

export const postUserFavouriteTags = (tag_ids: number[]): Promise<Response> => {
  return fetchAPI(`/self/user_favourite_tags`, {
    method: 'POST',
    version: '1.2',
    payload: { tag_ids },
  });
};



// WEBPACK FOOTER //
// ./app/api/entities.ts